module.exports = __webpack_public_path__ + "static/media/rightar.65ce1dc0.svg";